import styled from "styled-components";
import { Link as GatsbyLink } from "gatsby";

export const ResetPasswordLink = styled(GatsbyLink)`
  color: var(--creamWhite);
  margin-bottom: 20px;
  font-weight: ${(props) => (props.bold ? "700" : "400")};
  line-height: 26px;
`;
